import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { State } from '../../dave-data-module/State';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
    OpenEditDepartmentPopup,
} from '../../components/detail-views/detail-employee/employee-helper';
import { DepartmentEntity } from '../../dave-data-module/entities/department.entity';
import { AppButtonModule } from '../../dave-utils-module/app-button-module/app-button.module';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { CustomLabelService } from '../../services/custom-label/custom-label.service';
import { firstValueFrom } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-department-option[departmentEntity]',
    standalone: true,
    imports: [CommonModule, AppButtonModule, FontAwesomeModule, MatLegacyTooltipModule],
    templateUrl: './department-option.component.html',
    styleUrls: ['./department-option.component.scss']
})
export class DepartmentOptionComponent {
    @Input()  public departmentEntity: DepartmentEntity;
    constructor(private store: Store<State>, private dialog: MatDialog, protected cls: CustomLabelService) {
    }
    async edit (jsEntity: DepartmentEntity) {
        const label = await firstValueFrom(this.cls.getSingle$('Department'))
        OpenEditDepartmentPopup(jsEntity, this.dialog, this.store, label);
    }

}
